<div class="eiq-ellipse-text">
  <span
    #textElement
    class="eiq-ellipse-text-content fs__sm fw__400"
    [class.collapsed]="!expanded$()"
    [class.single-line]="singleLine()"
    [innerHTML]="text()"
  ></span>

  @if (showExpandable$()) {
    <span class="fs__sm fw__600 eiq-ellipse-text-button" (click)="toggle()">{{ expanded$() ? 'Less' : 'More' }}</span>
  }
</div>
